import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';

const OrderDetails = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/orders/${orderId}`)
      .then((res) => res.json())
      .then((data) => setOrder(data))
      .catch((err) => console.error('Failed to fetch order', err));
  }, [orderId]);

  if (!order) return <div>Loading...</div>;

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">

        {/* Breadcrumb */}
        <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner text-center">
                  <h2 className="title">Order Details</h2>
                  <ul className="page-list">
                    <li className="rbt-breadcrumb-item"><a href="/">Home</a></li>
                    <li><div className="icon-right"><i className="feather-chevron-right"></i></div></li>
                    <li className="rbt-breadcrumb-item"><a href="/past-orders">Orders</a></li>
                     <li><div className="icon-right"><i className="feather-chevron-right"></i></div></li>
                    <li className="rbt-breadcrumb-item active">Order Details</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Order Details */}
        <div className="container py-5">
          {/* <h3 className="mb-4">Order #{order.orderID}</h3> */}

          <div className="mb-3"><strong>Status:</strong> {order.orderStatus}</div>
          <div className="mb-3"><strong>Payment:</strong> {order.payment?.paymentStatus} (${order.payment?.amount.toFixed(2)})</div>
          <div className="mb-3"><strong>Tracking Number:</strong> {order.trackingNumber || "N/A"}</div>

          <h4 className="mt-5 mb-3">Items</h4>
          <table className="table table-bordered text-center">
            <thead>
              <tr>
                <th>Image</th>
                <th>Product</th>
                <th>Fabric</th>
                <th>Price</th>
                <th>Size</th>
                <th>Monogram</th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item) => (
                <tr key={item.orderItemId}>
                  <td>
                    <img
                      src={item.fabric?.displayImagePath || "/assets/images/default.jpg"}
                      alt={item.productName}
                      style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                    />
                  </td>
                  <td>{item.productName}</td>
                  <td>{item.fabricName}</td>
                  <td>${item.price.toFixed(2)}</td>
                  <td>{item.smartSizeName || "N/A"}</td>
                  <td>
                    {item.isMonogram
                      ? `${item.monogramInitials} (${item.monogramStyle}, ${item.monogramColor}, ${item.monogramPlacement})`
                      : "No"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4 className="mt-5 mb-3">Shipping Address</h4>
          <p>
            {order.shippingAddress}, {order.city}, {order.state} - {order.postalCode}, {order.country}
            <br />
            <strong>Phone:</strong> {order.phoneNumber}
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default OrderDetails;
